import React from "react";
import { Link } from "react-router-dom";
import {
  ListItem,
  makeStyles,
  createStyles,
  Tooltip,
  Theme,
} from "@material-ui/core";

/** スタイル定義 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const useStyles = makeStyles((_theme: Theme) =>
  createStyles({
    listItem: {
      paddingTop: 8,
      justifyContent: "center",
    },
  })
);

interface Props {
  tooltip: string;
  toUrl: string;
  icons: {
    active: React.ReactNode;
    inactive: React.ReactNode;
  };
  selected?: boolean;
}

/** サイドバーナビゲータアイテムSVG */
export function SidebarNavItemSvg(props: Props) {
  const classes = useStyles();

  const { tooltip, toUrl, icons, selected } = props;

  //--------------------
  // コンポーネント
  return (
    <ListItem button className={classes.listItem} component={Link} to={toUrl}>
      <Tooltip
        title={tooltip}
        enterDelay={800}
        leaveDelay={100}
        placement="right-start"
        arrow
      >
        <span>{selected ? icons.active : icons.inactive}</span>
      </Tooltip>
    </ListItem>
  );
}
